import * as React from 'react'
import '../scss/main.scss'
import Footer from "./footer"
import Header from "./header"
import parse from "html-react-parser";

const Layout = ({children, useSimpleHeaderAndFooter}) => {
    return (
        <>
            <Header useSimpleHeader={useSimpleHeaderAndFooter}/>
            <main>
                {children}
            </main>
            <Footer useSimpleFooter={useSimpleHeaderAndFooter}/>
        </>
    )
}
export default Layout